var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastUpdatedSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34 26.6c-1.5 3.7-4.4 6.8-8.5 8.3-7.5 2.8-15.9-1-18.7-8.6s1-15.9 8.6-18.7 15.9 1 18.7 8.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.5 27.6L20 21.3v-7.4M36.2 10.9l-1.7 5.9-6-1.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastUpdatedSimple);
export default __webpack_public_path__ + "static/media/lastUpdatedSimple.e20f2c4294b0bdb5dd3f27d16b87f556.svg";
export { ForwardRef as ReactComponent };